<template lang="pug">
  div
    table.table.table-striped.table-bordered
      tr
        td Статус
        td {{formatAnswer(data.body.content.main.status, 3)}}
      tr
        td Дата начала
        td
          span(v-if="data.body.content.main.begin_date!==undefined") {{data.body.content.main.begin_date | date}}
          span(v-if="data.body.content.main.begin_date===undefined") —

      tr
        td Дата окончания
        td
          span(v-if="data.body.content.main.end_date!==undefined") {{data.body.content.main.end_date | date}}
          span(v-if="data.body.content.main.end_date===undefined") —
      tr
        td Номер карты
        td {{formatAnswer(data.body.content.main.card_number, 2)}}
      tr
        td Тип
        td {{formatAnswer(data.body.content.main.checkup_type, 3)}}
      tr
        td Выездная работа
        td {{formatAnswer(data.body.content.main.is_fieldwork, 1)}}
      tr
        td Тип оплаты
        td {{formatAnswer(data.body.content.main.payment_type, 3)}}
      tr
        td Место обслуживания
        td {{formatAnswer(data.body.content.main.service_place, 3)}}
      tr
        td Принадлежит к коренным малочисленным народам Севера, Сибири и дальнего Востока
        td {{formatAnswer(data.body.content.main.is_north_native, 1)}}
      tr
        td Повод обращения
        td {{formatAnswer(data.body.content.main.recourse_reason, 3)}}
      tr
        td Категория граждан
        td {{formatAnswer(data.body.content.main.citizen_category, 3)}}
      tr
        td Вид медицинского обслуживания
        td {{formatAnswer(data.body.content.main.medical_service_type, 3)}}
      tr
        td Тип диспансеризации по ОМС
        td {{formatAnswer(data.body.content.main.dispanserization_type, 3)}}
      tr
        td Этап диспансеризации
        td {{formatAnswer(data.body.content.main.dispanserization_stage, 3)}}
      tr
        td Профиль медицинской помощи
        td {{formatAnswer(data.body.content.main.medical_assistance_profile, 3)}}
      tr
        td Способ оплаты медицинской помощи
        td {{formatAnswer(data.body.content.main.medical_assistance_payment_method, 3)}}
    table.table.table-striped.table-bordered
      tr
        td Рост
        td {{formatAnswer(data.body.content.results.height, 5, "см")}}
      tr
        td Вес
        td {{formatAnswer(data.body.content.results.weight, 5, "кг")}}
      tr
        td Диагнозы и подозрения
        td
          div(v-if="data.body.content.results.diagnoses && data.body.content.results.diagnoses.length > 0")
            span(v-for='diagnosis in data.body.content.results.diagnoses')
              b {{diagnosis.code}}
              span &nbsp;- {{diagnosis.icd_text?diagnosis.icd_text:diagnosis.diagnosis_text}}
              span(v-if='diagnosis.status && diagnosis.status.name') &nbsp;( {{diagnosis.status.name}} ({{!diagnosis.diagnosis_date ? "—" : diagnosis.diagnosis_date | date}}) )
              span(v-if="diagnosis.diagnosis_type" style="color: #595959;")
                br
                span &emsp;&emsp;&emsp;&emsp;{{diagnosis.diagnosis_type.name}}
                span(v-if="diagnosis.confirmation_date") &nbsp;({{diagnosis.confirmation_date|date}})
              br
          div(v-if="!data.body.content.results.diagnoses || data.body.content.results.diagnoses.length < 1") —
      tr
        td Окружность талии
        td {{formatAnswer(data.body.content.results.waistline, 5, "см")}}
      tr
        td Курение
        td {{formatAnswer(data.body.content.results.is_smoking, 1)}}
      tr
        td Холестерин
        td {{formatAnswer(data.body.content.results.cholesterol, 5, "ммоль/л")}}
      tr
        td Исход обращения
        td {{formatAnswer(data.body.content.results.case_outcome, 3)}}
      tr(v-if="data.body.content.results.risk_factors")
        td Факторы риска
        td
          div
            span.tname Ожирение:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.obesity, 1)}} {{formatAnswer(data.body.content.results.risk_factors.obesity, 7)}}

          div
            span.tname Курение табака:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.smoking, 1)}} {{formatAnswer(data.body.content.results.risk_factors.smoking, 7)}}
          div
            span.tname Избыточная масса тела:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.overweight, 1)}} {{formatAnswer(data.body.content.results.risk_factors.overweight, 7)}}
          div
            span.tname Гипергликемия:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.overweight, 1)}} {{formatAnswer(data.body.content.results.risk_factors.overweight, 7)}}
          div
            span.tname Нерациональное питание:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.mismanagement, 1)}} {{formatAnswer(data.body.content.results.risk_factors.mismanagement, 7)}}
          div
            span.tname Риск потребления наркотических средств и психотропных веществ:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.addiction_risk, 1)}} {{formatAnswer(data.body.content.results.risk_factors.addiction_risk, 7)}}
          div
            span.tname Риск пагубного потребления алкоголя:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.alcoholism_risk, 1)}} {{formatAnswer(data.body.content.results.risk_factors.alcoholism_risk, 7)}}
          div
            span.tname Риск старческой астении:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.senile_aging_risk, 1)}} {{formatAnswer(data.body.content.results.risk_factors.senile_aging_risk, 7)}}
          div
            span.tname Отягощенная наследственность по злокачественным новообразованиям:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.cancer_inheritance, 1)}} {{formatAnswer(data.body.content.results.risk_factors.cancer_inheritance, 7)}}
          div
            span.tname Отягощенная наследственность по ССЗ при наличии мозгового инсульта:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.stroke_inheritance, 1)}} {{formatAnswer(data.body.content.results.risk_factors.stroke_inheritance, 7)}}
          div
            span.tname Повышенный уровень АД:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.high_blood_pressure, 1)}} {{formatAnswer(data.body.content.results.risk_factors.high_blood_pressure, 7)}}
          div
            span.tname Отягощенная наследственность по сахарному диабету:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.diabetes_inheritance, 1)}} {{formatAnswer(data.body.content.results.risk_factors.diabetes_inheritance, 7)}}
          div
            span.tname Гиперхолистеринемия:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.hypercholesterolemia, 1)}} {{formatAnswer(data.body.content.results.risk_factors.hypercholesterolemia, 7)}}
          div
            span.tname Низкая физическая активность:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.low_physical_activity, 1)}} {{formatAnswer(data.body.content.results.risk_factors.low_physical_activity, 7)}}
          div
            span.tname Отягощенная наследственность по ССЗ при наличии инфаркта миокарда:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.infarction_inheritance, 1)}} {{formatAnswer(data.body.content.results.risk_factors.infarction_inheritance, 7)}}
          div
            span.tname Отягощенная наследственность по хроническим болезням нижних дыхательных путей:&nbsp;
            span {{formatAnswer(data.body.content.results.risk_factors.lower_respiratory_tract_diseases_inheritance, 1)}} {{formatAnswer(data.body.content.results.risk_factors.lower_respiratory_tract_diseases_inheritance, 7)}}
      tr
        td Систолическое давление
        td {{formatAnswer(data.body.content.results.systolic_pressure, 2)}}
      tr
        td Результат обращения
        td {{formatAnswer(data.body.content.results.case_discharge_type, 3)}}
      tr
        td Процент выполнения
        td {{formatAnswer(data.body.content.results.completion_percentage, 2)}}
      tr
        td Итог диспансеризации
        td
          span {{formatAnswer(data.body.content.results.dispanserization_result, 3)}}
          span( v-if="data.body.content.results.dispanserization_results.health_group_defined && data.body.content.results.dispanserization_results.health_group_defined.date") &nbsp;({{data.body.content.results.dispanserization_results.health_group_defined.date | date}})
      tr(v-if="data.body.content.results.dispanserization_results")
        td Результат диспансеризации (профосмотра)
        td
          div
            span.tname Группа здоровья:&nbsp;
            span {{formatAnswer(data.body.content.results.dispanserization_results.health_group_defined.health_group, 3)}}
          div
            span.tname Дано направление для получения специализированной, в том числе высокотехнологичной помощи:&nbsp;
            span {{formatAnswer(data.body.content.results.dispanserization_results.is_qualified_help, 1)}}
          div
            span.tname Направлен в реабилитационное отделение:&nbsp;
            span {{formatAnswer(data.body.content.results.dispanserization_results.refer_rehabilitation, 1)}}
          div(v-if="data.body.content.results.dispanserization_results.refer_rehabilitation!== undefined || data.body.content.results.dispanserization_results.refer_rehabilitation === null")
            span.tname Тип размещения в реабилитационном отделении:&nbsp;
            span {{formatAnswer(data.body.content.results.dispanserization_results.bed_profile, 8)}}
          div
            span.tname Тип диагностики:&nbsp;
            span(v-if="data.body.content.results.dispanserization_results.additional_diagnostics") {{formatAnswer(data.body.content.results.dispanserization_results.additional_diagnostics.diagnostics_type, 2)}}
            span(v-if="!data.body.content.results.dispanserization_results.additional_diagnostics") Нет
          div
            span.tname Дано направление на консультацию к врачу сердечно-сосудистому хирургу: &nbsp;
            span(v-if="data.body.content.results.dispanserization_results.refer_consultation") {{formatAnswer(data.body.content.results.dispanserization_results.refer_consultation.to_cardiovascular_surgeon, 4)}} {{formatAnswer(data.body.content.results.dispanserization_results.refer_consultation.to_cardiovascular_surgeon, 6)}}
            span(v-if="!data.body.content.results.dispanserization_results.refer_consultation") Нет
          div
            span.tname Дано направление на консультацию к врачу-психиатру (врачу психиатру-наркологу):&nbsp;
            span(v-if="data.body.content.results.dispanserization_results.refer_consultation") {{formatAnswer(data.body.content.results.dispanserization_results.refer_consultation.to_phychiatrist, 4)}} {{formatAnswer(data.body.content.results.dispanserization_results.refer_consultation.to_phychiatrist, 6)}}
            span(v-if="!data.body.content.results.dispanserization_results.refer_consultation") Нет
          div
            span.tname Дано направление на консультацию к врачу: &nbsp;
            span(v-if="data.body.content.results.dispanserization_results.refer_consultation") {{formatAnswer(data.body.content.results.dispanserization_results.refer_consultation.to_another_doctor, 4)}} {{formatAnswer(data.body.content.results.dispanserization_results.refer_consultation.to_another_doctor, 6)}}
            span(v-if="!data.body.content.results.dispanserization_results.refer_consultation") Нет
          div
            span.tname Назначено лечение: &nbsp;
            span {{formatAnswer(data.body.content.results.dispanserization_results.is_treatment_appointed, 1)}}
          div
            span.tname Дано направление на санаторно-курортное лечение: &nbsp;
            span {{formatAnswer(data.body.content.results.dispanserization_results.is_sanatorium_treatment, 1)}}
          div
            span.tname Взят под диспансерное наблюдение: &nbsp;
            span {{formatAnswer(data.body.content.results.dispanserization_results.is_dispensary_registration, 1)}}
          div
            span.tname Пациент отказался от диспансеризации: &nbsp;
            span {{formatAnswer(data.body.content.results.dispanserization_results.is_hospitalization_refusal, 1)}}
</template>
<script>
export default {
  props: ['data'],

  methods: {
    formatAnswer (fact, type, units) {

      switch (type) {
        case 1:
          return fact && fact !== undefined ? (fact ? 'Да' : 'Нет') : 'Нет'
        case 2:
          return fact || '—'
        case 3:
          return fact ? fact.name : '—'
        case 4:
          return fact && fact !== undefined
            ? fact
              ? fact.service_place
              : 'Нет'
            : 'Нет'
        case 5:
          return fact ? fact + ' ' + units : '—'
        case 6:
          return fact && fact !== undefined
            ? fact
              ? ' ('+fact.speciality+')'
              : 'Нет'
            : ''
        case 7:
          return fact ? '(' + fact.code + ')' : ''
        case 8:
          return fact && fact !== undefined ? (fact ? fact : '—') : '—'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
.tname
  color: #595959;
</style>
